class MRHeader extends HTMLElement {
    constructor() {
        super();

        this.overlay = this.querySelector('.header__overlay')

        this.button = this.querySelector('.header__hamburger')
        this.button?.addEventListener('click', this.toggleOverlay.bind(this))

        this.searchButton = this.querySelector('form label')
        this.searchInput = this.querySelector('.wp-block-search__inside-wrapper')
        this.searchButton?.addEventListener('click', this.toggleSearch.bind(this))

        this.navigationItems = this.querySelectorAll('.wp-block-navigation-item:not(.wp-block-navigation-item__container .sublink, .header__overlay--bottom .wp-block-navigation-item)')

        this.navigationSubLinks = this.querySelectorAll('.wp-block-navigation-item.sublink')

        this.navigationSubLinks.forEach(sublink => {
            sublink.addEventListener('click', (e) => e.stopImmediatePropagation())
        })


        this.searchForm = this.querySelector('form.wp-block-search')

        if(this.searchForm) {
            this.searchForm.submitButton = this.searchForm?.querySelector('button')
            this.searchForm?.submitButton.classList.add('btn')
        }

        this.headerSetUp()

        document.body.addEventListener('click', (e) => {
            if (!e.target.closest('header')) {
                if (this.overlay?.getAttribute('open')) this.closeOverlay()
            }
        })

        addEventListener('resize', this.headerSetUp.bind(this))

    }

    headerSetUp() {
        this.centerContainer = this.querySelector('.header__center')
        this.headerLinks = []
        if(this.centerContainer) {
            this.centerContainer.innerHTML = ''
        }
        if (!this.isMobile()) {

            this.searchForm?.classList.add('hide')

            this.navigationItems.forEach(item => {

                item.mainParent = this

                item.containerEl = item.querySelector('.wp-block-navigation-item__container')

                item.containerEl?.classList.add('active')
            })
            this.createDskMenu()

            this.headerLinks.forEach((el, index) => {
                el.addEventListener('click', () => {

                    this.searchForm?.classList.add('hide')
                    el.classList.add('active')
                    this.navigationItems.forEach((item, index2) => {
                        if (index === index2) {

                            item.classList.remove('hide')
                        } else {
                            this.headerLinks[index2].classList.remove('active')
                            item.classList.add('hide')
                        }
                    })
                })
            })

            this.searchIcon = this.querySelector('.wp-block-search__label')

            this.searchIcon?.addEventListener('click', (e) => {
                e.preventDefault()
                this.openOverlay()

                this.navigationItems.forEach(item => {
                    item.classList.add('hide')
                })
                this.headerLinks.forEach((el, index) => {

                    el.classList.remove('active')
                })

                this.searchForm?.classList.remove('hide')

            })

        } else {
            this.searchForm?.classList.remove('hide')
            this.navigationItems.forEach(item => {
                item.classList.remove('hide')
                item.containerEl?.classList.remove('active')
            })

            this.navigationItems.forEach(item => {

                item.mainParent = this

                item.containerEl = item.querySelector('.wp-block-navigation-item__container')

                item.content = item.querySelector('.wp-block-navigation-item__content')
                item.contentInitHeight = item?.content?.getBoundingClientRect().height
                if(item.content) {
                    item.content.style.height = item.contentInitHeight + 'px'
                }

                item.addEventListener('click',
                    this.toggleContainer
                )
            })
        }

    }

    isMobile() {
        return window.matchMedia('(max-width: 1023px)').matches
    }

    toggleOverlay() {
        this.overlay.toggleAttribute('open')
        this.toggleAttribute('open')
        if (this.isMobile()) document.body.classList.toggle('blocked')
        if(this.hasAttribute('open')){
            this.closest('header').style.zIndex = '99'
        } else {
            this.closest('header').style.zIndex = '9'
        }
    }

    openOverlay() {
        this.overlay.setAttribute('open', true)
        this.overlay.open = true
        if (this.isMobile()) {
            document.body.classList.add('blocked')
        }
        this.closest('header').style.zIndex = '99'

    }

    closeOverlay() {
        this.overlay.removeAttribute('open')
        this.headerLinks.forEach(link => {
            link.classList.remove('active')
        })
        this.overlay.open = false
        if (this.isMobile()) {
            document.body.classList.remove('blocked')
        }
        this.closest('header').style.zIndex = '9'
    }

    toggleSearch() {
        this.searchInput.classList.toggle('active')
    }

    closeContainer(item) {
        if (item.open) {
            item.content.style.height = item.contentInitHeight + 'px'
            item.containerEl.classList.remove('active')
            item.open = false
        }
    }

    toggleContainer() {

        this.mainParent.navigationItems.forEach(item => {
            if (item !== this) this.mainParent.closeContainer(item)
        })

        const marginOnTop = 18
        this.contentHeight = this.content.getBoundingClientRect().height
        this.containerElHeight = this.containerEl.getBoundingClientRect().height

        if (this.contentHeight === this.contentInitHeight) {
            this.content.style.height = this.contentHeight + this.containerElHeight + marginOnTop + 'px'
        } else {
            this.content.style.height = this.contentInitHeight + 'px'
        }

        this.containerEl.classList.toggle('active')

        this.open = !this.open

    }

    createDskMenu() {
        this.navigationItems.forEach((item, index) => {
            const newEl = document.createElement('a')
            newEl.classList.add('header__center--el')

            const label = item.querySelector('.wp-block-navigation-item__label')
            if(label) {
                newEl.innerText = label.innerText
                newEl.href = label.href
                newEl.target = label.target
            } else {
                newEl.innerText = item.innerText
                newEl.href = item.querySelector('a').href
                newEl.target = item.querySelector('a').target
            }

            this.centerContainer.appendChild(newEl)


            item.containerEl?.classList.add('active')

            if (index > 0) {
                item.classList.add('hide')
            }

            newEl.addEventListener('click', (e) => {
                //e.preventDefault()
                //this.openOverlay()
            })

            this.headerLinks.push(newEl)

        })

    }
}

customElements.define('mr-header', MRHeader)